import styled from 'styled-components';

import { spaceL, spaceXL, spaceXS } from '@xingternal/tokens';
import { Headline, Hero } from '@xingternal/typography';

import { lineClamp } from '@/utils/line-clamp';

export const StyledHero = styled(Hero)`
  ${lineClamp(3)}
  margin-bottom: ${spaceL};
`;

export const StyledHeadline = styled(Headline)`
  margin-bottom: ${spaceXL};
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${spaceXS};
`;
